import * as _ from 'lodash';

export function empty(object: any) {
    return _.isEmpty(object);
}

export function sort(array, key, asc = false) {
    if (asc) {
        return _.orderBy(array, [key], ['asc']);
    }
    return _.orderBy(array, [key], ['desc']);
}


export function hasWhiteSpace(s) {
    return /\s/g.test(s);
}